export const CheckboxesGroup = {
  parts: ['FormLegend', 'Grid', 'GridItem', 'Checkbox', 'HStack', 'HStackItem'],
  baseStyle: {
    FormLegend: {
      fontSize: 'lg',
      pb: '10',
      textAlign: 'center',
    },
    Grid: {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: 20,
    },
    GridItem: {
      width: '100%',
      border: '1px solid',
      borderColor: 'brand.midgrey2',
      borderRadius: '4px',
      p: '0',
    },
    GridItemChecked: {
      borderColor: 'brand.lightgreen',
    },
    Checkbox: {
      width: '100%',
      padding: 4,
      '> *:last-child': {
        /* work around to style Checkbox wrapper around label */
        width: '100%',
      },
      //  DEV NOTE: the chakra ui theming is done in the default component overrides
    },
    CheckboxChecked: {
      bg: 'brand.lightgreen2',
    },
    HStack: { width: '100%' },
    HStackItem: { fontSize: 'md' },
  },
};
